const colorsArray = ['#D4F9EC', '#ECF7FF', '#AF91E3', '#EBF674', '#E4EDEA'];
export const getSlideColor = (index: number): string => {
  if (index < 5) {
    return colorsArray[index];
  }
  return getSlideColor(index - 5);
};
